import { Helmet } from 'react-helmet-async';
// sections
import { HomeHero } from '../sections/home';
import { useSelector } from 'src/redux/store';
import Page from 'src/components/page/';

// ----------------------------------------------------------------------

export default function HomePage() {
  const { mtoConfig } = useSelector((state) => state.config);
  return (
    <>
      <Page title={mtoConfig?.title}>
        <HomeHero />

        {/* <Box
        sx={{
          overflow: 'hidden',
          position: 'relative',
          bgcolor: 'background.default',
        }}
      >
        <HomeMinimal />

        <HomeHugePackElements />

        <HomeForDesigner />

        <HomeDarkMode />

        <HomeColorPresets />

        <HomeCleanInterfaces />

        <HomePricingPlans />

        <HomeLookingFor />

        <HomeAdvertisement />
      </Box> */}
      </Page>
    </>
  );
}
